import { Link } from "react-router-dom";

/**
 * Unified breadcrumb component
 *
 * @param {Array} items - Array of { label, href } objects. Last item is current page (no href needed)
 * @param {string} className - Additional classes
 *
 * @example
 * <Breadcrumb items={[
 *   { label: "Home", href: "/" },
 *   { label: "Projects", href: "/projects" },
 *   { label: "Satori" }  // current page, no href
 * ]} />
 */
const Breadcrumb = ({ items, className = "" }) => {
  return (
    <nav className={`flex items-center gap-2 text-xs uppercase tracking-wider ${className}`}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <span key={index} className="flex items-center gap-2">
            {index > 0 && <span className="text-base-content/20">→</span>}
            {isLast ? (
              <span className="text-primary font-medium">{item.label}</span>
            ) : (
              <Link
                to={item.href}
                className="text-base-content/40 hover:text-base-content transition-colors"
              >
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
